import React, { useEffect } from 'react';
import NeuroViewer from './NeuroViewer';
import { PatientZScoresProvider } from './NormativeModeling';

function App() {
  useEffect(() => {
    // Disable browser scroll restoration
    if ('scrollRestoration' in window.history) {
      window.history.scrollRestoration = 'manual';
    }

    // Scroll to top on mount/refresh
    window.scrollTo(0, 0);

    // Also ensure body and html are at top
    document.documentElement.scrollTop = 0;
    document.body.scrollTop = 0;
  }, []);

  return (
    <div className="app">
      <PatientZScoresProvider>
        <NeuroViewer />
      </PatientZScoresProvider>
    </div>
  );
}

export default App;